module.exports = __webpack_public_path__ + "img/info-security-24.c5765fd8.svg";